import IncomeChartEastern from './IncomeChartEastern';

export default IncomeChartEastern;
